<template>
  <Banner />
  <section id="common_author_area" class="section_padding">
        <div class="container">
          <div class="row bg-light shadow-lg">
            <div class="col-sm-12 col-md-4 col-lg-3 pe-sm-2.5 pe-md-0 pe-lg-0">
              <div class="nav flex-column nav-pills my-1" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <button class="nav-link shadow-sm text-start py-4" id="hotels" data-bs-toggle="pill"
                  data-bs-target="#v-hotels" type="button" role="tab" aria-controls="v-hotels" aria-selected="false"
                  @click="handleTabClick('hotels')">
                  <strong>{{ $t("profitable_unit") }}</strong>
                  <span class="d-block"><small>{{ $t('copy_properties') }}</small></span>
                </button>
                <button class="nav-link shadow-sm text-start py-3" id="interest-places" data-bs-toggle="pill"
                  data-bs-target="#v-interest-places" type="button" role="tab" aria-controls="v-interest-places"
                  aria-selected="false" @click="handleTabClick('interest-places')">
                  <strong>{{ $t('register_place_interest') }}</strong><br>
                  <strong>{{ $t('copy_place_interest') }}</strong>
                </button>
                <button class="nav-link shadow-sm text-start py-4" id="travel-agency" data-bs-toggle="pill"
                  data-bs-target="#v-travel-agency" type="button" role="tab" aria-controls="v-travel-agency"
                  aria-selected="false" @click="handleTabClick('travel-agency')">
                  <strong>{{ $t("travel_agency") }}</strong>
                </button>
                <button class="nav-link active shadow-sm text-start py-4" id="trips" data-bs-toggle="pill"
                  data-bs-target="#v-trips" type="button" role="tab" aria-controls="v-trips" aria-selected="true"
                  @click="handleTabClick('trips')">
                  <strong>{{ $t("trips_in_selah") }}</strong>
                </button>
              </div>
            </div>

            <div class="col-sm-12 col-md-8 col-lg-9 bg-white border-1 rounded-3 p-3">
              <div class="tab-content" id="v-pills-tabContent">
                <h2 class="text-center my-2">{{ $t('register_') }}</h2>
                <div class="tab-pane mb-5 fade" id="v-hotels" role="tabpanel" aria-labelledby="hotels">
                  <RegisterOwnerForm />
                </div>
                <div class="tab-pane mb-5 fade" id="v-interest-places" role="tabpanel"
                  aria-labelledby="interest-places">
                  <CommonAuthorSix />
                </div>
                <div class="tab-pane mb-5 fade" id="v-travel-agency" role="tabpanel" aria-labelledby="travel-agency">
                  <RegisterAgencyForm />
                </div>
                <div class="tab-pane mb-5 fade show active" id="v-trips" role="tabpanel" aria-labelledby="trips">
                  <CommonAuthorThree />
                </div>
              </div>
            </div>
          </div>
        </div>
  </section>
</template>

<script>
import { onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Banner from "@/components/owner/Banner.vue";
import CommonAuthorThree from "@/components/user/CommonAuthorThree.vue";
import RegisterAgencyForm from "@/components/user/RegisterAgencyForm.vue";
import CommonAuthorSix from "@/components/user/CommonAuthorSix.vue";
import RegisterOwnerForm from "@/components/user/RegisterOwnerForm.vue";

export default {
  name: "RegisterHomeView",
  components: {
    Banner,
    CommonAuthorThree,
    RegisterAgencyForm,
    CommonAuthorSix,
    RegisterOwnerForm,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const setInitialTab = (tabId) => {
      const tab = document.getElementById(tabId);
      if (tab) {
        tab.click();
        return true;
      }
      return false;
    };

    const handleTabClick = (tabId) => {
      router.replace({ hash: `#${tabId}` });
    };

    onMounted(() => {
      const initialTab = route.hash ? route.hash.replace('#', '') : 'hotels';
      const didSetInitialTab = setInitialTab(initialTab);
      if (!didSetInitialTab && initialTab !== 'hotels') {
        if (setInitialTab('hotels')) {
          router.replace({ hash: '#hotels' });
        }
      }
    });

    watch(
      () => route.hash,
      (newHash) => {
        const targetTab = newHash ? newHash.replace('#', '') : 'hotels';
        const didSetTab = setInitialTab(targetTab);
        if (!didSetTab && targetTab !== 'hotels') {
          if (setInitialTab('hotels')) {
            router.replace({ hash: '#hotels' });
          }
        }
      }
    );

    return {
      handleTabClick,
    };
  },
};
</script>
  
